import { REGISTER } from "redux-persist";





export const apiConstants = {

  Invoices: {
    UPLOAD_INVOICE: "FMS/Invoice/UploadInvoice",
    GET_INVOICE_FILES: "FMS/Invoice/GetInvoiceFilesList",
    GET_INVOICE_BY_ID: "FMS/Invoice/GetInvoiceById",
    PROCESS_FILE: "FMS/Invoice/ProcessFile",
    GET_INVOICE_LIST: "FMS/Invoice/GetInvoiceList",
    CANCEL_INVOICE: "FMS/Invoice/CancelInvoice",
    APPROVE_INVOICE: "FMS/Invoice/ApproveInvoice",
    SUBMIT_FOR_APPROVAL: "FMS/Invoice/SubmitForApproval",
    ADD_INVOICE: "FMS/Invoice/AddInvoice",
    UPDATE_INVOICE: "FMS/Invoice/UpdateInvoice",
    GET_INVOICES_TYPE: "FMS/Invoice/GetInvoiceTypes",
    AUDIT_INVOICES: "FMS/Invoice/GetInvoiceHistory",
    LOGIN: "Identity/api/Account/Login",
    GET_PROCESSED_INVOICES_BY_ID: "FMS/Invoice/GetProcessedInvoiceDataById",
    GENERATE_OUTPUT_FILE: "FMS/Invoice/GenerateOutputFile",
    DELETE_INVOICE_BY_ID: "FMS/Invoice/DeleteInvoiceFileById",
    UPLOAD_REVERSE_FILE: "FMS/Invoice/UploadReverseFile",
    GET_BANK_DETAILS: "OnBoardingApi/api/Customer/GetIfscDetails",
    GENERATE_MIS_REPORT: "FMS/Master/GenerateHDFCMISReport",
    GENERATE_PAYMENT_ADVICE: "FMS/PaymentAdvice/GeneratePaymentAdvice",
    GET_PAYMENT_ADVICE: "FMS/PaymentAdvice/GetPaymentAdviceList",
    UPDATE_PAYMENT_ADVICE: "FMS/PaymentAdvice/UpdatePaymentAdvice",
    GENERATE_PAYMENT_REPORT: "FMS/Vendor/GenerateBankFileText",
    GET_BENE_REQUEST_DATA: "FMS/Vendor/GetBeneRequestData",
    INITIATE_TEST: "FMS/Vendor/InitiateTest",
    HDFC_BENE_REGISTERATION: "FMS/Vendor/HDFCBeneRegistration",
    GET_APPROVAL_MATRIX: "FMS/Invoice/getApprovalMatrix"
  },
  Property: {
    PROPERTY_LIST: "FMS/Property/GetPropertyList",
    GET_USER_BY_PROPERTYID: "FMS/Property/GetUsersByPropertyId",
    UPLOAD_PROPERTY: "FMS/Property/UploadProperty",
    CANCEL_PROP: "FMS/Property/CancelProperty",
    APPROVE_PROP: "FMS/Property/ApproveProperty",
    AUDIT_PROPERTY: "FMS/Property/GetPropertyHistory",
    GET_VENDOR_BY_PROP_ID: "FMS/Invoice/GetVendorsByPropertyId",
    SET_PROPERTY_ACTIVE: "FMS/Property/SetPropertyActive",
    REGISTER_NEW_PROPERTY: "FMS/Property/AddProperty",
    ADD_OR_UPDATE_PROPERTY_VENDOR: "FMS/Property/AddUpdatePropertyVendors",
    REMOVE_PROPERTY_VENDOR: "FMS/Property/RemovePropertyVendors",
    UPDATE_PROPERTY: "FMS/Property/UpdateProperty",
    GET_PROPERTY_BY_ID: "FMS/Property/GetPropertyById",
    GET_PROPERTY_HISTORY: "FMS/Property/GetPropertyHistory"


  },
  AUTH: {
    FORGOT_PASSWORD: "Identity/api/Account/ForgotPassword",
    RESEND_OTP: "Identity/api/OTP/GenerateCustomOTP",
    RESET_PASSWORD: "Identity/api/Account/ResetPassword",
    CHANGE_PASSWORD: "Identity/api/Account/ChangePassword",
    CHANGE_PASSWORD_FOR_NEW_USER: "Identity/api/Account/SetPasswordForNewUser",
    REGISTER_USER: "Identity/api/Account/RegisterUser",
    GET_PERMISSIONS: "Identity/api/NavigationPermission/GetNavigationItemsByRole",
    GET_PERMISSION_HEIRARCHY: "Identity/api/NavigationPermission/GetPermissionHierarchy",
    SAVE_PERMISSION_ROLE_WISE: "Identity/api/NavigationPermission/SavePermisisonsRoleWise",
    GET_ALL_ROLES: "Identity/api/NavigationPermission/GetAllRoles",
    GET_ROLES: "Identity/api/Account/GetRoles"
  },
  DASH: {
    GET_TOTAL_PAYABLE: "FMS/DashBoard/GetTotalPayable",
    GET_TOTAL_PAYOUT: "FMS/DashBoard/GetTotalPayout",
    GET_TOTAL_INVOICEOVERDUE: "FMS/DashBoard/GetTotalInvoiceOverdue",
    GET_TOTAL_PENDING_FOR_APPROVAL: "FMS/DashBoard/GetPendingforApprovalInvoiceCount",
    GET_TOTAL_AGREEMENT_EXPIRED: "FMS/DashBoard/GetAgreementExpiredIn30DaysCount",
    GET_TOTAL_PAYOUT_LAST_6_MONTH: "FMS/DashBoard/GetTotalPayoutLast6Months",
    GET_TOTAL_HIGHEST_PAID_INVOICE: "FMS/DashBoard/GetTop10HighestPaidInvoicelist",


  },

  VENDOR: {
    ADD_VENDOR: "FMS/Vendor/AddVendor",
    GET_VENDORS: "FMS/Vendor/GetVendorList",
    GET_VENDORBYID: "FMS/Vendor/GetVendorById",
    UPDATE_VENDOR: "FMS/Vendor/UpdateVendor",
    GET_VENDOR_EXCLUDE_PROPERTY_ID: "FMS/Vendor/GetVendorExcludingAssociated",
    GET_GSTIN_DETAIL: "api/v2.0/PANValidation/GetEnteredGSTINDetail",

  },
  USER: {
    GET_USERS: "FMS/User/GetNotAssociatedUserList",
    ASSIN_USER: "FMS/User/AssignPropertyUser",

    UPDATE_VENDOR: "FMS/Vendor/UpdateVendor",
    GET_VENDOR_EXCLUDE_PROPERTY_ID: "FMS/Vendor/GetVendorExcludingAssociated",
    DISASSOCIATE_USER: "FMS/User/DisassociatePropertyUser",
    Revoke_Token: "FMS/User/RevokeToken"

  },

  GET_INVOICE_BY_EMAIL: {
    VERIFY_TOKEN: "FMS/Invoice/GetEmailApprovalData"
  }
}